import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { goBack } from '@/utils/utils';
import useGCPI18n from '@/hooks/useGCPI18n';

import Header from '@/components/Header';
import ExpiredImg from '@/assets/images/ic_no_campaign@2x.png';

import style from './index.less';

const Expired = () => {
  const [tipId, setTipId] = useState('lb_expired_titleinfo');
  const GCPI18n = useGCPI18n();

  useEffect(() => {
    const initAppStr = window.localStorage.getItem('initApp');
    const initApp = JSON.parse(initAppStr) || {};
    if (isEmpty(initApp.phone)) {
      setTipId('lb_expired_phone');
    }
  }, []);

  return (
    <div className={style.page}>
      <div className={style.container}>
        <Header title="" goBack={goBack} />
        <div className={style.backImg}>
          <div className={style.infoBox}>
            <img src={ExpiredImg} alt="" />
            <div className={style.titleInfo}>{GCPI18n(tipId)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expired;
